import moment from 'moment'
import {useEffect, useState} from 'react'

import {OrderCancellationOptions} from '../../OrderIntake/declarations/types'
import {Order} from '../../Pages/Order/Order.types'

import {calculateCancellationTimeWindow} from './calculateCancellationTimeWindow'
import {CancellationTimeWindow} from './types'

export const useOrderCancellationTimeWindow = (
  order: Order,
  options: OrderCancellationOptions | undefined,
  onCancellationCutOffTimeReached: (timePast: boolean) => void,
  refreshMs: number = 1000,
  nowProvider: () => moment.Moment = () => moment.utc()
): CancellationTimeWindow =>
  useCancellationTimeWindow(
    order.orderManagement?.cancellableUntil,
    options?.businessHoursOptions.cutOffTimeThreshold,
    onCancellationCutOffTimeReached,
    refreshMs,
    nowProvider
  )

export const useCancellationTimeWindow = (
  cancellableUntil: string | undefined,
  cutOffTimeThreshold: string | undefined,
  onCancellationCutOffTimeReached: (timePast: boolean) => void,
  refreshMs: number = 1000,
  nowProvider: () => moment.Moment = () => moment.utc()
): CancellationTimeWindow => {
  const [timeWindow, setTimeWindow] = useState<CancellationTimeWindow>(
    calculateCancellationTimeWindow(cancellableUntil, cutOffTimeThreshold, nowProvider)
  )

  useEffect(() => {
    onCancellationCutOffTimeReached(!timeWindow.isCancellable)
  }, [onCancellationCutOffTimeReached, timeWindow.isCancellable])

  useEffect(() => {
    if (!timeWindow.isTimerActive) {
      return
    }

    const interval = setInterval(() => {
      setTimeWindow(
        calculateCancellationTimeWindow(cancellableUntil, cutOffTimeThreshold, nowProvider)
      )
    }, refreshMs)

    return () => clearInterval(interval)
  }, [cancellableUntil, cutOffTimeThreshold, refreshMs, timeWindow.isTimerActive, nowProvider])

  return timeWindow
}
